/**
 * Voyado-identifisering.
 *
 * Setter `va('setContactId', ...)` så cart-tracking knyttes til en kontakt
 * (forutsetning for abandoned cart). Identiteten lagres i localStorage og
 * gjenbrukes på senere sidelaster - også for ikke-innloggede - slik at en
 * kunde som melder seg på nyhetsbrev blir identifisert selv om Voyado ikke
 * har rukket å synke kontakten med en gang (Trigg -> Voyado).
 *
 * Globals satt inline i theme.liquid:
 *   window.VOYADO_WORKER   - base-URL til Cloudflare-workeren
 *   window.VOYADO_CUSTOMER - { email, phone } for innloggede kunder (valgfritt)
 */
(function () {
  var WORKER = window.VOYADO_WORKER;
  var KEY_ID = 'voyado_contact_id';
  var KEY_PENDING = 'voyado_pending_phone';

  function get(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function set(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }
  function remove(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }

  function apply(contactId) {
    if (!contactId) return;
    set(KEY_ID, contactId);
    if (window.va) va('setContactId', contactId);
  }

  // Slår opp kontakt i workeren. `query` er f.eks. "phone=%2B47..." eller
  // "email=...". Returnerer Voyado-svaret, eller null ved feil.
  function lookup(query) {
    if (!WORKER) return Promise.resolve(null);
    return fetch(WORKER + '/voyado/contact-id?' + query)
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  // Slår opp og identifiserer hvis kontakt finnes og har samtykke for dette
  // brandet. Workeren returnerer kun contactId når samtykke finnes (consent-gaten
  // håndheves server-side). Hvis den ikke kan løses ennå og et telefonnummer er
  // oppgitt, lagres nummeret så neste sidelast kan prøve igjen.
  function resolve(query, phoneToPersist) {
    return lookup(query).then(function (data) {
      if (data && data.contactId) {
        remove(KEY_PENDING);
        apply(data.contactId);
        return true;
      }
      if (phoneToPersist) set(KEY_PENDING, phoneToPersist);
      return false;
    });
  }

  window.VoyadoId = { apply: apply, lookup: lookup, resolve: resolve };

  // --- Bootstrap på sidelast ---

  // 1. Innlogget kunde har forrang: oppdater og lagre identitet hver last.
  var customer = window.VOYADO_CUSTOMER;
  if (customer && customer.email) {
    var q = 'email=' + encodeURIComponent(customer.email);
    if (customer.phone) q += '&phone=' + encodeURIComponent(customer.phone);
    resolve(q);
    return;
  }

  // 2. Allerede identifisert i en tidligere økt: bare re-sett, gjør ingenting mer.
  var stored = get(KEY_ID);
  if (stored) {
    if (window.va) va('setContactId', stored);
    return;
  }

  // 3. Påmelding som ikke rakk å synke til Voyado: prøv oppslaget på nytt.
  var pending = get(KEY_PENDING);
  if (pending) {
    resolve('phone=' + encodeURIComponent(pending), pending);
  }
})();
